export const DEFAULT_RETRY = 3;
export const DEFAULT_TIMEOUT = 5 * 60_000; // 5 min
export const DEFAULT_STALE_TIME = DEFAULT_TIMEOUT;
export const DEFAULT_RETRY_BACKOFF = (attempt: number) =>
  Math.min(1000 * (1 << attempt), 30_000);
